import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';

import { Script } from '../../../techstyle-shared/react-marketing';
import { AfterpayStyles } from '../../styles/afterpay';

export default function AfterpaySnippet({ onReady }) {
  const afterpayScript = config.get('public.afterpay.script');
  return (
    <>
      <AfterpayStyles />
      <Script
        skipServerRender
        src="https://static-us.afterpay.com/javascript/present-afterpay.js"
        globalScriptKey="afterpay-widget-checkout"
        onReady={onReady}
      />
      {/* ?: Does this need to have a `globalScriptKey` and `skipServerRender`? */}
      <Script src={afterpayScript} />
    </>
  );
}

AfterpaySnippet.propTypes = {
  onReady: PropTypes.func.isRequired,
};
